import { getDisaster, putDisaster } from '../../../../api/eastCoastDataApi/setting/DisasterReachSetting'
import CONST from '../../../../utils/const'
import Utils from '../../../../utils/utils'

const state = {
  disasters : [],
}

const getters = {
  getScienicDisasters: state => (condition = {scienicId: 0}) => {
    return disasters.filter(disaster => disaster.scenicAreaId === condition.scienicId)
  },
}

const actions = {
  async getDisasters({ commit }) {
    const result = await getDisaster()
    if(result.success) {
      commit('disasters', result.data)
    }
  },

  async putDisasters({commit}, disasters) {
    const results = [] // 地震一次會有兩筆disaster

    for(let i = 0 ; i < disasters.length ; i++) {
      const result = await putDisaster(disasters[i])

      if (result.success) {
        commit('updateDisaster', { data: disasters[i], mode: 'put' })
      }
      results.push(result)
    }

    console.log('putDisasters', results)
    let failedCount = results.filter(r => r.success === false).length

    return failedCount > 0 ? {success : false} : {success : true}
  }
}

const mutations = {
  disasters(state, data) {
    if(Utils.isEmptyObject(data)) {
      return
    }

    state.disasters = data
  },

  updateDisaster(state, { data, mode }) {
    switch (mode) {
      case 'post':
        state.disasters.push(data)
        break
      
      case 'put':
        let target = state.disasters.find(d => d.id === data.id)
        // 直接 target = data 不會觸發mapState更新
        target.content = data.content
        target.magnitudeValue = data.magnitudeValue
        
        break
  
      case 'delete' :
        // state.disasters = state.disasters.filter(d => d.id !== data)
        break    
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}